import React, { useCallback, useState, useEffect } from "react";
import { withRouter } from "react-router";
import firebase from "../config/firebase";

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import validate from 'validate.js'; 
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Muicelular from 'material-ui-phone-number';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" >
        Unidos Para Ayudar
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

var RegExpPhone = /\+5989\d{7}/
const schema = {
  celular: {
    presence: { allowEmpty: false, message: 'es obligatorio' },
    format: {
      pattern: RegExpPhone,
      flags: "i",
      message: "debe ser en formato internacional (+5989XNNNNNN)"
    }
  },
  cedula: {
    presence: { allowEmpty: false, message: 'es obligatoria' },
    length: {
      minimum: 7,
      maximum: 8
    }
  },
  nombre: {
    presence: { allowEmpty: false, message: 'es obligatorio' },
    length: {
      maximum: 32
    }
  },
  apellido: {
    presence: { allowEmpty: false, message: 'es obligatorio' },
    length: {
      maximum: 32
    }
  },
  email: {
    presence: { allowEmpty: false, message: 'es obligatorio' },
    email: true,
    length: {
      maximum: 64
    }
  },
  password: {
    presence: { allowEmpty: false, message: 'es obligatorio' },
    length: {
      maximum: 128
    }
  },
};

const SignUp = ({ history }) => {

  const classes = useStyles();
  const [formState, setFormState] = useState({
    isValid: false,
    values: {
      nombre   : "",
      apellido : "",
      email    : "",
      password : "",
      cedula   : "", 
      celular  : ""
    },
    touched: {},
    errors: {}
  });
  
  const handleSignUp = useCallback(async event => {
    event.preventDefault();
    const { email, nombre, apellido, celular, password , cedula } = event.target.elements;
    const userProfile = {
      email       : email.value.toUpperCase(),
      nombre      : nombre.value.toUpperCase(),
      apellido    : apellido.value.toUpperCase(),
      celular     : celular.value.toUpperCase(),
      cedula      : cedula.value.toUpperCase(),
      covid       : 0,
      created     : firebase.firestore.FieldValue.serverTimestamp()
    }
    try {
      await firebase
        .auth()
        .createUserWithEmailAndPassword(email.value, password.value)
        .then(
          (userCredential) => {
            if(userCredential.user){
              firebase.firestore().collection('orgs').doc('unidos')
                .collection('users')
                  .doc(userCredential.user.uid).set(userProfile)
            }
            userCredential.user.sendEmailVerification();
        });
        history.push("/");
      } catch (error) {
        alert(error);
      }
    }
  );

    const handleChange = event => {
      event.persist();
      setFormState(formState => ({
        ...formState,
        values: {
          ...formState.values,
          [event.target.name]:
            event.target.type === 'checkbox'
              ? event.target.checked
              : event.target.value
        },
        touched: {
          ...formState.touched,
          [event.target.name]: true
        }
      }));
    };

    const hasError = field =>
      formState.touched[field] && formState.errors[field] ? true : false;
  

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState(formState => ({
      ...formState,
      isValid: errors ? false : true,
      errors: errors || {}
    }));
  }, [formState.values]);


 
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Registrarse
        </Typography>
        <form
                className={classes.form}
                onSubmit={handleSignUp}
              >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                autoComplete="fname"
                name="nombre"
                variant="outlined"
                required
                fullWidth
                id="nombre"
                label="Nombre"
                autoFocus
                className={classes.textField}
                error={hasError('nombre')}
                helperText={
                  hasError('nombre') ? formState.errors.nombre[0] : null
                }
                onChange={handleChange}
                type="text"
                value={formState.values.nombre || ''}
            />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="apellido"
                label="Apellido"
                name="apellido"
                autoComplete="lname"
                className={classes.textField}
                error={hasError('apellido')}
                helperText={
                  hasError('apellido') ? formState.errors.apellido[0] : null
                }
                onChange={handleChange}
                type="text"
                value={formState.values.apellido || ''}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Celular" name="celular" id="celular" variant="outlined"
                required
                fullWidth
                autoComplete="celular"
                className={classes.textField}
                error={hasError('celular')}
                helperText={
                  hasError('celular') ? formState.errors.celular[0] : null
                }
                onChange={handleChange}
                type="text"
                value={formState.values.celular || ''}
                variant="outlined"
                />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Cedula" name="cedula" id="cedula"  variant="outlined"
                required
                fullWidth
                autoComplete="cedula"
                className={classes.textField}
                error={hasError('cedula')}
                helperText={
                  hasError('cedula') ? formState.errors.cedula[0] : null
                }
                onChange={handleChange}
                type="text"
                value={formState.values.cedula || ''}
                variant="outlined"
                />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                id="email"
                label="Email"
                name="email"
                autoComplete="email"
                className={classes.textField}
                error={hasError('email')}
                helperText={
                  hasError('email') ? formState.errors.email[0] : null
                }
                onChange={handleChange}
                type="text"
                value={formState.values.email || ''}
              
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                name="password"
                label="Contraseña"
                type="password"
                id="password"
                autoComplete="current-password"
                className={classes.textField}
                  error={hasError('password')}
                  helperText={
                    hasError('password') ? formState.errors.password[0] : null
                  }
                onChange={handleChange}
                type="password"
                value={formState.values.password || ''}
              />
            </Grid>
          </Grid>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={!formState.isValid}
            className={classes.submit}
          >
            Registrarse
          </Button>
          <Grid container justify="flex-end">
            <Grid item>
              <Link href="login" variant="body2">
                ¿Ya tenés cuenta? Registrate...
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={5}>
        <Copyright />
      </Box>
    </Container>
  );
};

export default withRouter(SignUp);